$(document).on('click', '.news-cont-js .pagination a', function(e) {
  e.preventDefault();
  showLoadingOverlay();
  let url = $(this).attr('href');
  $.get(url, content => {
    content = $($.parseHTML(content));
    let html = content.find('.news-cont-js').html();
    let title = content.find('title').text() || document.title;
    history.pushState({url}, title, url);
    document.title = title;

    let $cont = $(this).closest('.news-cont-js');
    $cont.html(html);
    $('html,body').animate({
      scrollTop: $cont.offset().top - 200,
    });
    hideLoadingOverlay();
  });
});